// extracted by mini-css-extract-plugin
export default {"wrapper":"PreviewWrapper_wrapper__mQh9T","desktop":"PreviewWrapper_desktop__nZ6KB","phone":"PreviewWrapper_phone__QTAaL","tablet":"PreviewWrapper_tablet__Co5NX"};